import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { Button } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';

import { useCreateReturnContext } from '../../../../../context/create-return-provider';

import messages from './messages';
import style from './style.module.less';

export const Footer = ({ onClose }) => {
  const { isValid, updateShipTo } = useCreateReturnContext();

  const onSave = useCallback(() => {
    updateShipTo();
    onClose();
  }, [onClose, updateShipTo]);

  return (
    <ModalFooter className={style['edit-address-footer']}>
      <FlexRow className={style['edit-address-footer-buttons']}>
        <div className={style['edit-address-footer-right-side']}>
          <ModalFooterCancelButton />
          <Button disabled={!isValid} onClick={onSave} theme='primary'>
            <FormattedMessage {...messages.saveButton} />
          </Button>
        </div>
      </FlexRow>
    </ModalFooter>
  );
};

Footer.propTypes = {
  onClose: PropTypes.func.isRequired,
};
